import type { StaffAccessEvent } from '../shared/types';

// Five exact pre-launch events approved by Alex for display-only cleanup.
// Keep the API response, immutable audit records, and all future events intact.
const hiddenPrelaunchEventIds = new Set([
	'cf6090e0-1559-4b51-b2b9-2ef6c5b50b29',
	'582fff6a-4e9c-4684-b13c-1f4692f6b812',
	'823eeea4-ef9b-4fb6-8dbc-d3899356a257',
	'8edff921-3959-4803-af88-bae8ae81fdc8',
	'334e929e-6de7-43e5-be47-daacc8f3233c',
]);

export function visibleAccessHistory(events: StaffAccessEvent[]): StaffAccessEvent[] {
	return events.filter((event) => !hiddenPrelaunchEventIds.has(event.id));
}
